document.addEventListener('DOMContentLoaded', function () {
  var checkin = document.getElementById('rf-checkin');
  var checkout = document.getElementById('rf-checkout');
  var jumlah = document.getElementById('rf-hari');
  if (!checkin || !checkout) return;

  checkin.min = new Date().toISOString().split('T')[0];

  function hitungHari() {
    var d1 = new Date(checkin.value);
    var d2 = new Date(checkout.value);
    if (checkin.value && checkout.value) {
      if (d2 <= d1) {
        checkout.setCustomValidity('Tanggal check-out harus setelah check-in');
        jumlah.value = '';
      } else {
        checkout.setCustomValidity('');
        jumlah.value = Math.round((d2 - d1) / (1000 * 60 * 60 * 24));
      }
    }
  }

  checkin.addEventListener('change', function () {
    checkout.min = checkin.value;
    hitungHari();
  });
  checkout.addEventListener('change', hitungHari);

  function ambilData() {
    var form = document.getElementById('booking-form-rf');
    if (!form || !form.checkValidity()) {
      if (form) form.reportValidity();
      return null;
    }
    return {
      nama: document.getElementById('rf-nama').value,
      ktp: document.getElementById('rf-ktp').value,
      alamat: document.getElementById('rf-alamat').value,
      hp: document.getElementById('rf-hp').value,
      checkin: checkin.value,
      checkout: checkout.value,
      hari: jumlah.value
    };
  }

  var btnWa = document.getElementById('rf-btn-wa');
  if (btnWa) {
    btnWa.addEventListener('click', function () {
      var d = ambilData();
      if (!d) return;
      var pesan = '🌿 *PENDAFTARAN BOOKING*\n\n'
        + '👤 *Nama Lengkap:* ' + d.nama + '\n'
        + '🏠 *Nomor KTP:* ' + d.ktp + '\n'
        + '📍 *Alamat:* ' + d.alamat + '\n'
        + '📱 *Nomor HP:* ' + d.hp + '\n'
        + '📅 *Check-in:* ' + d.checkin + '\n'
        + '📅 *Check-out:* ' + d.checkout + '\n'
        + '⏳ *Jumlah Hari:* ' + d.hari + ' hari';
      window.open('https://wa.me/6283846571134?text=' + encodeURIComponent(pesan), '_blank');
    });
  }

  var btnEmail = document.getElementById('rf-btn-email');
  if (btnEmail) {
    btnEmail.addEventListener('click', function () {
      var d = ambilData();
      if (!d) return;
      var subjek = 'Pendaftaran Booking - ' + d.nama;
      var isi = 'PENDAFTARAN BOOKING\n\n'
        + 'Nama Lengkap: ' + d.nama + '\n'
        + 'Nomor KTP: ' + d.ktp + '\n'
        + 'Alamat: ' + d.alamat + '\n'
        + 'Nomor HP: ' + d.hp + '\n'
        + 'Tanggal Check-in: ' + d.checkin + '\n'
        + 'Tanggal Check-out: ' + d.checkout + '\n'
        + 'Jumlah Hari: ' + d.hari + ' hari';
      window.location.href = 'mailto:rfherbs@yahoo.com?subject=' + encodeURIComponent(subjek) + '&body=' + encodeURIComponent(isi);
    });
  }
});
